import makeEvents from "../../../../helpers/event-creator.js";
const APP_EVENTS = makeEvents([
    'forgot-pass-form-submitted',
    'login-form-submitted'
]);
export default APP_EVENTS;
